import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpInlineToastComponent } from "./bp-inline-toast.component";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	declarations: [BpInlineToastComponent],
	exports: [BpInlineToastComponent],
	imports: [CommonModule, CoreModule]
})
export class BpInlineToastModule {}
